import { render, staticRenderFns } from "./general-data.vue?vue&type=template&id=00168a1a&"
import script from "./general-data.vue?vue&type=script&lang=js&"
export * from "./general-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports